export function playMouseClick() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const bufLen = Math.ceil(ctx.sampleRate * 0.018);
    const buf = ctx.createBuffer(1, bufLen, ctx.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < bufLen; i++)
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufLen, 4);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.55, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.025);
    const lp = ctx.createBiquadFilter();
    lp.type = 'lowpass';
    lp.frequency.value = 3500;
    src.connect(lp);
    lp.connect(gain);
    gain.connect(ctx.destination);
    src.start();
  } catch (_) {}
}
